export interface SlashCommand {
  command: string;   // ex: "/help"
  label: string;     // ex: "Aide & commandes"
  description: string;
}

export const COMMANDS: SlashCommand[] = [
  { command: '/help',  label: 'Aide',           description: 'Afficher les commandes disponibles' },
  { command: '/rag',   label: 'Mode documents',  description: 'Interroger les documents du dossier actif' },
  { command: '/reset', label: 'Nouvelle session',description: 'Réinitialiser la conversation' },
  { command: '/exit',  label: 'Terminer',        description: 'Terminer la session agent' },
];
